
import { defineComponent,onMounted, ref  } from "vue";
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
    name: "AuthPhoneComplete",
    setup() {
        const route = useRoute();
        const processMode = ref("");

        onMounted(() => {
            processMode.value = route.query.processMode as string;
        });

        return {
            processMode
        };
    }
});

